export type StatementPart =
  | { type: 'text'; content: string }
  | { type: 'image'; content: string }
  | { type: 'code'; content: string; lang?: string };

const TOKEN_REGEX =
  /\[CODE(?::\s*([^\]\s]+))?\]([\s\S]*?)\[\/CODE\]|\[IMAGE:\s*(https?:\/\/[^\]]+)\]/g;

function trimSingleSurroundingNewline(value: string): string {
  let result = value;
  if (result.startsWith('\r\n')) {
    result = result.slice(2);
  } else if (result.startsWith('\n')) {
    result = result.slice(1);
  }
  if (result.endsWith('\r\n')) {
    result = result.slice(0, -2);
  } else if (result.endsWith('\n')) {
    result = result.slice(0, -1);
  }
  return result;
}

export function parseQuestionContent(input: string | null | undefined): StatementPart[] {
  const parts: StatementPart[] = [];
  if (!input) {
    return parts;
  }

  let lastIndex = 0;
  let match: RegExpExecArray | null;

  TOKEN_REGEX.lastIndex = 0;
  while ((match = TOKEN_REGEX.exec(input)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', content: input.slice(lastIndex, match.index) });
    }

    if (match[2] !== undefined) {
      const lang = match[1]?.trim();
      const content = trimSingleSurroundingNewline(match[2]);
      parts.push(lang ? { type: 'code', content, lang } : { type: 'code', content });
    } else if (match[3] !== undefined) {
      parts.push({ type: 'image', content: match[3].trim() });
    }

    lastIndex = TOKEN_REGEX.lastIndex;
  }

  if (lastIndex < input.length) {
    parts.push({ type: 'text', content: input.slice(lastIndex) });
  }

  return parts;
}
